/**
 * 관리자 등록/수정 폼 — $j.F.Admin.ManagerEditForm (정적 모듈)
 *
 * 폼은 adm/pages/managerEdit.blade.php (JBModal 'jb-modal-manager' 로 로드). 여는 쪽이 onOpen 에서 init() 을 부른다.
 * 신규는 id 중복·pw 규칙, 수정은 pw 를 넣었을 때만 규칙을 본다(jquery-validate).
 */
// 신규등록: id 중복체크 + pw 규칙체크, 수정: pw 입력했을 때만 규칙체크
function _initValidateRegister(){
    $('#inputform').validate({
        rules: {
            manage_id:  { required: true, minlength: 4, remote: '/adm/ajax/manager/duplicate' },
            manage_pwd: { required: true, minlength: 8, remote: '/adm/ajax/manager/passwd/validate' }
        },
        messages: {
            manage_id:  { required: '아이디를 입력해주세요', minlength: '4글자 이상 입력해주세요', remote: '동일한 아이디가 존재합니다' },
            manage_pwd: { required: '패스워드를 입력해주세요', minlength: '8글자 이상 입력해주세요', remote: '영문,숫자,특수문자를 포함한 8글자 이상 입력해주세요.' }
        },
        submitHandler: save
    });
}
function _initValidateModify(){
    $('#inputform').validate({
        rules: {
            manage_pwd: { required: false, minlength: 8, remote: '/adm/ajax/manager/passwd/validate' }
        },
        messages: {
            manage_pwd: { minlength: '8글자 이상 입력해주세요', remote: '영문,숫자,특수문자를 포함한 8글자 이상 입력해주세요.' }
        },
        submitHandler: save
    });
}

function save(){
    const num = parseInt($('input[name="num"]').val(), 10) || 0;
    const url = num ? '/adm/ajax/manager/modify' : '/adm/ajax/manager';

    $.ajax({
        type: 'POST',
        url: url,
        data: $('#inputform').serialize(),
        success: function(data){
            if (data && data.result) {
                $j.F.Admin.Util.tsalert('success', '입력에 성공했습니다');
                $j.Common.EventBus.trigger('adm:manager:saved', data);
                $j.Ui.JBModal.close('jb-modal-manager');
            } else {
                $j.F.Admin.Util.tsalert('error', '입력에 실패했습니다');
            }
        }
    });
}

function boot(){
    const isModify = !!parseInt($('input[name="num"]').val(), 10);
    isModify ? _initValidateModify() : _initValidateRegister();

    // 불러톡을 끄면 '진동 2번'도 잠근다 — 받지도 않는 톡의 진동 옵션은 뜻이 없다
    $('#sw_talk').on('change', function(){
        $('#sw_talk_vib').prop('disabled', !this.checked);
        if (!this.checked) $('#sw_talk_vib').prop('checked', false);
    });
}

export default class ManagerEditForm {
    static init() {
        // jquery-validate 는 동적 로드될 수 있음
        if (typeof $.fn.validate === 'undefined') {
            $.getScript('https://cdn.jsdelivr.net/npm/jquery-validation@1.20.1/dist/jquery.validate.min.js', boot);
        } else {
            boot();
        }
    }
}
